import { TaskRecurrenceType } from 'aos-services/src/services/tasks/types/task/TaskRecurrenceType'
import {
    allWeekDays,
    TaskRecurrenceWeekDay,
    translateTaskDay,
} from 'aos-services/src/services/tasks/types/task/TaskRecurrenceWeekly'
import { ChipToggleGroup, VStack } from 'aos-ui-universal'
import React, { FC } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskFormField } from '../../TaskFormField'
import { NumberField } from './NumberField'
import { NumberRowField } from './NumberRowField'
import { TaskRecurrenceFormProps } from './TaskRecurrenceFormProps'

export const TaskRecurrenceWeekly: FC<TaskRecurrenceWeeklyProps> = ({
    value,
    onChange,
    errors,
    canEdit,
}) => {
    const { t: translate } = useTranslation()
    if (value?.type !== TaskRecurrenceType.Weekly) {
        return null
    }

    return (
        <VStack className='shrink-0 gap-4'>
            <NumberRowField
                prefixLabel={translate('every', { ns: 'tasks' })}
                suffixLabel={translate('weeks', { ns: 'tasks' })}
                error={errors?.every ? translate('every.error', { ns: 'tasks' }) : undefined}
            >
                <NumberField
                    className='w-16'
                    value={value.every}
                    onChange={every => onChange({ every })}
                    disabled={!canEdit}
                />
            </NumberRowField>
            <TaskFormField
                label={translate('on', { ns: 'tasks' })}
                error={errors?.weekDays ? translate('weekly.on.error', { ns: 'tasks' }) : undefined}
            >
                <ChipToggleGroup
                    options={allWeekDays.map(day => ({
                        value: day,
                        label: translateTaskDay(translate)(day),
                    }))}
                    value={value.weekDays}
                    onChange={weekDays =>
                        onChange({ weekDays: weekDays as TaskRecurrenceWeekDay[] })
                    }
                    disabled={!canEdit}
                    className='flex-nowrap gap-1'
                    chipClassName='min-w-0 flex-1 px-1'
                />
            </TaskFormField>
        </VStack>
    )
}

interface TaskRecurrenceWeeklyProps extends TaskRecurrenceFormProps {
    errors?: FieldErrors<any>
}
